module.exports = __webpack_public_path__ + "img/visa.c640b55c.svg";